import { ContentReducer } from "./Redux/Reducers/contentReducer";
import { formReducer } from "./Redux/Reducers/formReducer";
import { screenReducer } from "./Redux/Reducers/screenReducer";
import { userReducer } from "./Redux/Reducers/userReducer";
import { storeReducer } from "./Redux/Reducers/storeReducer";
import { seasonalMenuReducer } from "./Redux/Reducers/seasonalMenuReducer";
import { paymentReducer } from "./Redux/Reducers/paymentReducer";
import { changeRequestReducer } from "./Redux/Reducers/changeRequestReducer";
import { menuMasterReducer } from "./Redux/Reducers/menuMasterReducer";

const { combineReducers } = require("redux");
const { playlistReducer } = require("./Redux/Reducers/playlistReducer");

export const rootReducer = combineReducers({
  Playlist: playlistReducer,
  Screen: screenReducer,
  Content: ContentReducer,
  Form: formReducer,
  User: userReducer,
  Store: storeReducer,
  SeasonalMenu: seasonalMenuReducer,
  Payment: paymentReducer,
  ChangeRequest: changeRequestReducer,
  MenuMaster: menuMasterReducer,
});
